import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "../../components/helpers/datetime";
import BaseReducer from "./BaseReducer";
import { enforcementVisitOptions } from "@common/components/helpers/options/enforcementVisitOptions";

class UnresolvedDisputeReducer extends BaseReducer {
  domain = "UnresolvedDispute";
  type = "View";

  initialState = {
    types: enforcementVisitOptions,
    // the selected customer
    customerId: null,
    customer: null,
    customerUnknown: false,
    // the form data
    formData: {
      id: null,
      complianceId: null,
      rowVersion: null,
      date: getDatePart(getCurrentDateTime()),
      time: getTimePart(getCurrentDateTime()),
      type: "",
      sessionGuids: [],
      machine: null,
      machineReference: null,
      description: "",
      cctvCatched: null,
      signature: "",
    },
  };
}

const reducer = new UnresolvedDisputeReducer();

export default reducer;
